<!-- 定时设置 -->
<template>
    <div class='container containerBox'>
        <div class="title">定时描述</div>
        <el-form :inline="true" label-width="100px" :model="handleForm" :rules="time_rules" ref="handleForm" class="demo-form-inline">
            <el-form-item label="名称" prop="timername">
                <el-input v-model="handleForm.timername" clearable placeholder="请输入名称"></el-input>
            </el-form-item>
            <el-form-item label="设备类型" prop="devtype">
                <el-select v-model="handleForm.devtype" :disabled="true" placeholder="设备类型">
                    <el-option label="PLC" :value="4"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="启用状态" prop="enable">
                <el-select v-model="handleForm.enable" clearable placeholder="设备类型">
                    <el-option label="启用" :value="true"></el-option>
                    <el-option label="禁用" :value="false"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="说明">
                <el-input v-model="handleForm.description" clearable placeholder="请输入说明"></el-input>
            </el-form-item>
        </el-form>
        <div class="title">设置时间</div>
        <el-form label-width="100px" :model="timeForm" :rules="time_rules" ref="timeForm" class="demo-form-inline setting-time">
            <el-form-item label="时间类型">
                <el-switch
                    style="display: block;width:200px;"
                    v-model="timeForm.value4"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    inactive-text="按星期管理"
                    active-text="按日期管理"
                    >
                </el-switch>
            </el-form-item>
            <el-form-item v-if="timeForm.value4" key="dates" label="定时日期" prop="dates">
                <el-date-picker
                    style="width:100%;"
                    type="dates"
                    v-model="timeForm.dates"
                    clearable
                    value-format="yyyy-MM-dd"
                    placeholder="选择一个或多个日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item v-else key="check" label="星期设置" prop="ckeckList">
                <el-checkbox-group v-model="timeForm.ckeckList">
                    <el-checkbox label="1">星期一</el-checkbox>
                    <el-checkbox label="2">星期二</el-checkbox>
                    <el-checkbox label="3">星期三</el-checkbox>
                    <el-checkbox label="4">星期四</el-checkbox>
                    <br>
                    <el-checkbox label="5">星期五</el-checkbox>
                    <el-checkbox label="6">星期六</el-checkbox>
                    <el-checkbox label="7">星期日</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="时间选择" prop="time">
                <el-time-picker
                    style="width:100%;"
                    v-model="timeForm.time"
                    clearable
                    @change="changeInput()"
                    format="HH:mm"
                    value-format="HH:mm"
                    placeholder="请选择时间">
                </el-time-picker>
            </el-form-item>
            <el-form-item label="定时时间">
                   <el-input v-model="timeForm.times" placeholder="请输入时间"></el-input>
        </el-form-item>
        </el-form>
        <div class="title">控制设备</div>
        <!-- 控制对象 -->
        <el-form :inline="true" :model="controlform" :rules="time_rules" ref="controlform"  class="demo-form-inline">
            <el-form-item label="集控器" prop="collector">
                <el-select v-model="controlform.collector" placeholder="请选择集控器" @change="getnew()">
                    <el-option
                        v-for="item in collectorList"
                        :key="item.oid"
                        :label="item.dev_name"
                        :value="item.oid">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="设备" prop="device">
                <el-select v-model="controlform.device" placeholder="请选择设备">
                    <el-option
                        v-for="item in deviceList"
                        :key="item.oid"
                        :label="item.device_model+'：'+item.terminal_serial"
                        :disabled="item.dev_type != 4"
                        :value="item.oid">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="开启/关闭">
                <el-radio v-model="controlValue" :label="1">系统启动</el-radio>
                <el-radio v-model="controlValue" :label="0">系统停止</el-radio>
            </el-form-item>
        </el-form>
        <div>
            <el-button type="primary" @click="handleSave()">保存定时</el-button>
        </div>
    </div>
</template>

<script>
import Service from '@/api/Service'

export default {
    name:  'timersetting',
    data() {
        return {
            // 
            handleForm: {
                devtype: 4,
                timername: '',
                enable: true,
                description: '',
            },
            rules: {},
            // 设置时间
            timeForm: {
                value4: false,
                dates: [],
                ckeckList: [],
                time: '',
                times: '',
            },
            time_rules: {
				timername: [{ required: true, message: '请输入名称', trigger: 'blur' }],
                dates: [{required: true, message: '请选择日期', trigger: 'change' }],
                time: [{required: true, message: '请选择时间', trigger: 'change' }],
                ckeckList: [{ type: 'array', required: true, message: '请至少选择一天', trigger: 'change' }],
				collector: [{ required: true, message: '请选择集控器', trigger: 'change' }],
				device: [{ required: true, message: '请选择设备', trigger: 'change' }],
            },
            // 控制对象
            controlform: {
                collector: "",
                device: '',
            },
            collectorList: [],
            deviceList: [],

            controlValue: 1,
        };
    },

    components: {},

    computed: {},

    mounted() {
        let oid = this.$route.params.timingId
        if(oid>0) {
            this.getTimerInfo(oid);
        }
    },

    created() {
        this.getList();
    },

    methods: {
        // 获取信息
        async getTimerInfo(oid) {
            let data = await Service.getTimerInfo({oid: oid});
            if(data) {
                this.handleForm.description = data.Description;
                this.handleForm.devtype = data.Devtype
                this.handleForm.enable = data.Enable
                this.handleForm.timername = data.Timername
                this.handleForm.oid = data.OID
                this.controlform.device = JSON.parse(data.TimerControlDev).terminalid
                this.timeForm = this.fmtDate(data.TimerTime)
               
                this.controlValue = JSON.parse(data.TimerControlValue)[0].V[0]
            }
        },
		getnew(){
			this.getDeviceList(this.controlform.collector)
		},
        fmtDate(data){
            let settingTime = {}
            let Timer_time = JSON.parse(data);
            if (Timer_time.type === 'day') {
                settingTime.value4 = true;
                settingTime.dates = Timer_time.data.map(v => { return v.value});
				settingTime.ckeckList = []
            } 
            if (Timer_time.type === 'week') {
                settingTime.value4 = false;
                settingTime.ckeckList = Timer_time.data.map(v => { return v.value });
            }
            settingTime.time = Timer_time.time;
            settingTime.times = Timer_time.time;
            return settingTime
        },
        // 获取集控器列表
        async getList() {
            this.loading = true;
            let data = await Service.getCollector();
            this.loading = false;
            if(data){
                data = data === 'success' ? [] : data;
                this.collectorList = data;
                this.controlform.collector = data[0].oid;
                this.getDeviceList(this.controlform.collector);
            }
        },
        async getDeviceList(oid) {
            // let { oid } = obj
            let params = Object.assign({}, { page_num: 1, page_sum: 500 }, {OID: oid});
            let data = await Service.getMeter(params);
            if(data) {
                let list = data.list == null ? [] : data.list;
                this.deviceList = list;
            }
        },

        fmtTimer(data) {
            let obj = {}
            if(data.value4) {
                obj.type = "day"
                obj.data = [];
                data.dates.map(v=>{
                    obj.data.push({value: v})
                })
            }else{
                obj.type = "week"
                obj.data = [];
                data.ckeckList.map(v=>{
                    obj.data.push({value: v})
                })
            }
            obj.time = data.times
            return obj
        },
        async handleSave() {
			this.$refs['handleForm'].validate((valid) => {
				if (valid) {
					this.$refs['timeForm'].validate((valid) => {
						if (valid) {
							this.$refs['controlform'].validate(async (valid) => {
								if (valid){
										let timer_control_dev = { 
											opcode: 5,
											terminalid: this.controlform.device
										} 
										let timer_time = this.fmtTimer(this.timeForm)
										let timer_control_value = [{N: 1608, V: [this.controlValue]}]

										let params = Object.assign({}, this.handleForm)
										params.timer_time = timer_time;
										params.timer_control_dev = timer_control_dev;
										params.timer_control_value = timer_control_value;

										let data
										if(this.handleForm.oid) {
											data = await Service.editTimer(params);
										}else{
											data = await Service.addTimer(params);
										}
										if(data) {
											this.$message({
												type: "success",
												message: "操作成功"
											})
											this.$router.push('/timerMana')
										}
								}
							})
						}
					})
				
			} else {
				console.log('error submit!!');
				return false;
				}
			});			
            // let timer_control_dev = { 
            //     opcode: 5,
            //     terminalid: this.controlform.device
            // } 
            // let timer_time = this.fmtTimer(this.timeForm)
            // let timer_control_value = [{N: 1608, V: [this.controlValue]}]

            // let params = Object.assign({}, this.handleForm)
            // params.timer_time = timer_time;
            // params.timer_control_dev = timer_control_dev;
            // params.timer_control_value = timer_control_value;

            // let data
            // if(this.handleForm.oid) {
            //     data = await Service.editTimer(params);
            // }else{s
            //     data = await Service.addTimer(params);
            // }
            // if(data) {
            //     this.$message({
            //         type: "success",
            //         message: "操作成功"
            //     })
            //     this.$router.push('/timerMana')
            // }
        },
        changeInput(){
            if (this.timeForm.time!=""){
                if(this.timeForm.time!="")
                {
                    if(this.timeForm.times.indexOf(this.timeForm.time)==-1)
                    {
                        if(this.timeForm.times!="")
                        {
                            var str =this.timeForm.times.substr(this.timeForm.times.length -1, this.timeForm.times.length);
                            if (str == ";")
                            {
                                this.timeForm.times = this.timeForm.times+this.timeForm.time;
                            }
                            else
                            {
                                this.timeForm.times = this.timeForm.times+";"+this.timeForm.time;
                            }
                        }
                        else
                        {
                            this.timeForm.times = this.timeForm.time;
                        }
                    }
                }
            }
        }
    }
}

</script>
<style lang='less' scoped>
    .title{
        font-size: 20px;
        color: #333;
        line-height: 44px;
        border-bottom: 1px solid #ccc;
        margin-bottom: 15px;
    }
</style>